import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { PayablesDashboard } from '../components/payables/payablesDashboard';
import { ReceivablesDashboard } from '../components/receivables/receivablesDashboard';
import { ReceivablesBillsDashboard } from '../components/receivablesBills/receivablesBillsDashboard';
import { SpecialServicingLoanDashboard } from '../components/loan/specialServicingLoanDashboard';
import { PayablesApprovedDashboard } from '../components/payables/payablesApprovedDashboard';
import { PayableAttestationDashboard } from '../components/Attestation/payableAttestationDashboard';
import { LoanVendorDashboard } from '../components/loan/loanVendorDashboard';
import { RefundsDashboard } from '../components/refunds/refundsDashboard';
import { ProtectiveAdvancesDashboard } from '../components/protectiveAdvancesDashboard';
import { ServicingTransfersDashboard } from '../components/servicingTransfers/servicingTransfersDashboard';
import { PrincipalAmortizationDashboard } from '../components/principalAmortization/principalAmortizationDashboard';


export const getSpecialServicingRoutesConfig = (
  basePath: string,
  baseUrl: string,
  loanId: any,
  type: any = '',
) => {
  return {
    specialServicingReceivableDashboard: {
      path: `${basePath}/special-servicing/receivables-dashboard`,
      url: `${baseUrl}/special-servicing/receivables-dashboard`,
      documentTitle: 'Special Servicing Receivables Dashboard',
    },
    specialServicingPayableDashboard: {
      path: `${basePath}/special-servicing/payables-dashboard`,
      url: `${baseUrl}/special-servicing/payables-dashboard`,
      documentTitle: 'Special Servicing Payable Dashboard',
    },
    specialServicingReceivableBillsDashboard: {
      path: `${basePath}/special-servicing/receivables-bills-dashboard`,
      url: `${baseUrl}/special-servicing/receivables-bills-dashboard`,
      documentTitle: 'Special Servicing Receivables Bills Dashboard',
    },
    specialServicingLoanDashboard: {
      path: `${basePath}/special-servicing/loan-dashboard`,
      url: `${baseUrl}/special-servicing/loan-dashboard`,
      documentTitle: `Special Servicing Loan=[${loanId}] Dashboard`,
    },
    specialServicingPayablesApprovedDashboard: {
      path: `${basePath}/special-servicing/payables-approved-dashboard`,
      url: `${baseUrl}/special-servicing/payables-approved-dashboard`,
      documentTitle: `Special Servicing Approved Dashboard`,
    },
    specialServicingAttestationDashboard: {
      path: `${basePath}/special-servicing/attestation`,
      url: `${baseUrl}/special-servicing/attestation`,
      documentTitle: `Attestation`,
      loanId: { loanId },
      type: { type }
    },
    loanVendorDashboard: {
      path: `${basePath}/special-servicing/loan-vendor`,
      url: `${baseUrl}/special-servicing/loan-vendor`,
      loanId: { loanId }
    },
    specialServicingRefundsDashboard: {
      path: `${basePath}/special-servicing/refunds-dashboard`,
      url: `${baseUrl}/special-servicing/refunds-dashboard`,
      documentTitle: 'Special Servicing Refunds Dashboard',
    },
    protectiveAdvancesDashboard: {
      path: `${basePath}/special-servicing/protective_advances`,
      url: `${baseUrl}/special-servicing/protective_advances`,
      documentTitle: 'Special Servicing Protective Advances',
    },
    servicingTransfersDashboard: {
      path: `${basePath}/special-servicing/servicing-transfers`,
      url: `${baseUrl}/special-servicing/servicing-transfers`,
      documentTitle: 'Servicing Transfers Dashboard',
    },
    principalAmortizationDashboard: {
      path: `${basePath}/special-servicing/principal-amortization`,
      url: `${baseUrl}/special-servicing/principal-amortization`,
      documentTitle: 'Principal Amortization Dashboard',
    },
    principalAmortizationDashboardByLoan: {
      path: `${basePath}/special-servicing/principal-amortization/:loanId`,
      url: `${baseUrl}/special-servicing/principal-amortization/:loanId`,
      documentTitle: 'Principal Amortization Dashboard',
    },
  };
};

export const getSpecialServicingRoutes = (basePath: string, baseUrl: string, loanId: any, type: any = '') => {
  const config = getSpecialServicingRoutesConfig(basePath, baseUrl, loanId, type);

  return {
    specialServicingReceivableDashboard: (
      <Route exact path={config.specialServicingReceivableDashboard.path}>
        <Page routeDefinition={config.specialServicingReceivableDashboard}>
          <ReceivablesDashboard />
        </Page>
      </Route>
    ),
    specialServicingPayableDashboard: (
      <Route exact path={config.specialServicingPayableDashboard.path}>
        <Page routeDefinition={config.specialServicingPayableDashboard}>
          <PayablesDashboard />
        </Page>
      </Route>
    ),
    specialServicingReceivableBillsDashboard: (
      <Route exact path={config.specialServicingReceivableBillsDashboard.path}>
        <Page routeDefinition={config.specialServicingReceivableBillsDashboard}>
          <ReceivablesBillsDashboard />
          {/*<PayablesApprovedDashboard />*/}
        </Page>
      </Route>
    ),
    specialServicingLoanDashboard: (
      <Route exact path={config.specialServicingLoanDashboard.path}>
        <Page routeDefinition={config.specialServicingLoanDashboard}>
          <SpecialServicingLoanDashboard loanId={loanId} />
        </Page>
      </Route>
    ),
    specialServicingPayablesApprovedDashboard: (
      <Route exact path={config.specialServicingPayablesApprovedDashboard.path}>
        <Page routeDefinition={config.specialServicingPayablesApprovedDashboard}>
          <PayablesApprovedDashboard />
        </Page>
      </Route>
    ),
    specialServicingAttestationDashboard: (
      <Route exact path={config.specialServicingAttestationDashboard.path}>
        <Page routeDefinition={config.specialServicingAttestationDashboard}>
          <PayableAttestationDashboard loanId={config.specialServicingAttestationDashboard.loanId} type={config.specialServicingAttestationDashboard.type} />
        </Page>
      </Route>
    ),
    loanVendorDashboard: (
      <Route exact path={config.loanVendorDashboard.path}>
        <Page routeDefinition={config.loanVendorDashboard}>
          <LoanVendorDashboard />
        </Page>
      </Route>
    ),
    specialServicingRefundsDashboard: (
      <Route exact path={config.specialServicingRefundsDashboard.path}>
        <Page routeDefinition={config.specialServicingRefundsDashboard}>
          <RefundsDashboard />
        </Page>
      </Route>
    ),
    protectiveAdvancesDashboard: (
      <Route exact path={config.protectiveAdvancesDashboard.path}>
        <Page routeDefinition={config.protectiveAdvancesDashboard}>
          <ProtectiveAdvancesDashboard />
        </Page>
      </Route>
    ),
    servicingTransfersDashboard: (
      <Route exact path={config.servicingTransfersDashboard.path}>
        <Page routeDefinition={config.servicingTransfersDashboard}>
          <ServicingTransfersDashboard />
        </Page>
      </Route>
    ),
    principalAmortizationDashboard: (
      <Route exact path={config.principalAmortizationDashboard.path}>
        <Page routeDefinition={config.principalAmortizationDashboard}>
          <PrincipalAmortizationDashboard />
        </Page>
      </Route>
    ),
    principalAmortizationDashboardByLoan: (
      <Route exact path={config.principalAmortizationDashboardByLoan.path}>
        <Page routeDefinition={config.principalAmortizationDashboardByLoan}>
          <PrincipalAmortizationDashboard />
        </Page>
      </Route>
    ),
  };
};
